export default __webpack_public_path__ + "static/media/item_6@3x.55ecf959.webp";